export default __webpack_public_path__ + "static/brand-7-5d6e52ca06c89deb9f17af2fc30cf277.png";